module.exports = __webpack_public_path__ + "media/2200-2_YR_2021_Spyware.9d52fc77.mp4";